// extracted by mini-css-extract-plugin
module.exports = {"AdSlotBranding__desktop":"pf_a","AdSlotBranding__mobile":"pf_b","AdSlotBranding--branding":"pf_c","body--branding":"pf_e","body--billboard":"pf_f"};